import React from "react";
import { AppBar, Toolbar, Box, Button, IconButton, Container, Paper, Drawer, } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme, useMediaQuery } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Link } from "@mui/material"
import Logo from "../../assets/PURIFF_Logo_1-01.png";
import { useLocation,useNavigate } from "react-router-dom";

const menuItems = [
  { id: "home", label: "Home", path: "/" },
  { id: "products", label: "Products", path: "/product" },
  { id: "advice", label: "Advice & Care", path: "/advice-care" },
  { id: "contactus", label: "Contact Us", path: "/contactus" },

  // { id: "news", label: "News & Media", path:"/newsMedia"},
];

const animatedButtonSx = {
  borderRadius: "30px",
  px: 3,
  textTransform: "none",
  fontWeight: 600,
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  overflow: "hidden",

  "&:hover .btn-text": {
    animation: "textFromTop 0.45s cubic-bezier(0.16,1,0.3,1)",
  },
  "& .btn-text": {
    animation: "textFromBottom 0.45s cubic-bezier(0.16,1,0.3,1)",
  },

  "&:hover .arrow-icon": {
    animation: "arrowIconIn 0.45s cubic-bezier(0.16,1,0.3,1)",
  },
  "& .arrow-icon": {
    animation: "arrowIconOut 0.45s cubic-bezier(0.16,1,0.3,1)",
  },

  "@media (max-width:900px)": {
    "& .btn-text, & .arrow-icon": {
      animation: "none !important",
      transform: "none",
      opacity: 1,
    },
  },

  "@keyframes textFromTop": {
    "0%": { transform: "translateY(-14px)", opacity: 0 },
    "100%": { transform: "translateY(0)", opacity: 1 },
  },
  "@keyframes textFromBottom": {
    "0%": { transform: "translateY(14px)", opacity: 0 },
    "100%": { transform: "translateY(0)", opacity: 1 },
  },
  "@keyframes arrowIconIn": {
    "0%": { transform: "translateX(10px)", opacity: 0 },
    "100%": { transform: "translateX(0)", opacity: 1 },
  },
  "@keyframes arrowIconOut": {
    "0%": { transform: "translateX(0)", opacity: 1 },
    "100%": { transform: "translateX(10px)", opacity: 0 },
  },
};

export default function Header() {
  const [activeMenu, setActiveMenu] = React.useState(null);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [mobileActiveMenu, setMobileActiveMenu] = React.useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();

  const handleMenuClick = (item) => {  

    // ✅ If it's a normal menu (no dropdown)
    if (!item.dropdown) {
      setActiveMenu(null);

      // 👉 SAME PAGE CLICK → scroll to top
      if (location.pathname === item.path) {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }

      return;
    }

    // ✅ Dropdown logic (unchanged)
    setActiveMenu(activeMenu === item.id ? null : item.id);
  };


  const handleMobileMenuClick = (item) => {
    if (!item.dropdown) {
      setMobileOpen(false);
      return;
    }
    setMobileActiveMenu(
      mobileActiveMenu === item.id ? null : item.id
    );
  };
  const closeAllMenus = () => {
    setActiveMenu(null);
    setMobileActiveMenu(null);
    setMobileOpen(false);
  };
  React.useEffect(() => {
    closeAllMenus();
  }, [isMobile]);

  // 🔹 SAME MEGA MENU FOR DESKTOP & MOBILE
  const renderProductsMegaMenu = () => (
    <Paper
      elevation={8}
      sx={{
        width: {
          xs: "100%",
          sm: 360,
          md: 420,
        },
        maxWidth: "100%",
        borderRadius: 4,
        p: { xs: 2, md: 3 },
      }}

    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        {/* TOP CONTENT */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Link
            component={RouterLink}
            to="/product"
            onClickCapture={closeAllMenus}
            sx={{

              fontWeight: 700,
              fontSize: 20,
              textTransform: "none",
              color: "primary.main",
              px: 0,
              minWidth: "auto",
              textDecoration: "underline",
            }}
          >
            Products
          </Link>

          <Box sx={{ ml: 2.5, mr: 1, color: "primary.main", fontSize: 20 }}>
            •
          </Box>

          <Link
            component={RouterLink}
            to="/product"
            onClickCapture={closeAllMenus}

            sx={{
              textTransform: "none",
              color: "primary.main",
              px: 0,
              minWidth: "auto",
              fontWeight: 500,
              textDecoration: "underline",
            }}
          >
            View full range of products
          </Link>
        </Box>

        {/* PRODUCT CARD */}
        <Box
          sx={{
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 3,
            p: 2,
            display: "flex",
            gap: 2,
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src="/images/image-box.png"
            sx={{
              width: 90,
              height: 90,
              borderRadius: 2,
              backgroundColor: "primary.light",
              p: 1,
            }}
          />
          <Box>
            <Box sx={{ fontWeight: 700 }}>
              <Link
                component={RouterLink}
                to="/products/original-baby-wipes"
                underline="none"
                color="inherit"
                onClickCapture={closeAllMenus}
                sx={{
                  fontWeight: 700,
                  fontSize: 16,
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                Original Baby Wipes
              </Link>
            </Box>
            <Box sx={{ fontSize: 14, color: "text.secondary" }}>
              Gentle cleaning for newborn and sensitive skin.
            </Box>
          </Box>
        </Box>
      </Box>
    </Paper>
  );

  // 🔹 NEWS & MEDIA MEGA MENU
  const renderNewsMegaMenu = () => (
    <Paper
      elevation={6}
      sx={{
        width: {
          xs: "100%",
          sm: 600,
          md: 780,
        },
        maxWidth: "100%",
        borderRadius: 4,
        p: { xs: 2, md: 4 },
      }}

    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
        {/* TOP */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Link
            component={RouterLink}
            to="/newsMedia"
            onClickCapture={closeAllMenus}

            sx={{
              fontWeight: 700,
              fontSize: 20,
              textTransform: "none",
              color: "primary.main",
              px: 0,
              minWidth: "auto",
              textDecoration: "underline",
            }}
          >
            News & Media
          </Link>

          <Box sx={{ ml: 2.5, mr: 1, color: "primary.main", fontSize: 20 }}>
            •
          </Box>

          <Link
            component={RouterLink}
            to="/newsMedia"
            onClickCapture={closeAllMenus}
            sx={{
              textTransform: "none",
              color: "primary.main",
              px: 0,
              minWidth: "auto",
              fontWeight: 500,
              textDecoration: "underline",
            }}
          >
            View All
          </Link>
        </Box>

        {/* GRID */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              md: "repeat(2, 1fr)"
            },
            gap: 3,
          }}
        >
          {[
            {
              img: "/images/image-box.png",
              title: "Celebrating 2025",
              path: "/news/celebrating-2025"
            },
            {
              img: "/images/image-box.png",
              title: "Gender Pay Gap Report 2024",
              path: "/news/GenderPayGap2024"
            },
            {
              img: "/images/image-box.png",
              title: "Gender Pay Gap Report 2023",
              path: "/news/GenderPayGap2023"
            },
            {
              img: "/images/image-box.png",
              title: "Gender Pay Gap Report 2022",
              path: "/news/GenderPayGap2022"
            },
          ].map((item, index) => (
            <Link
              component={RouterLink}
              to={item.path}
              onClickCapture={closeAllMenus}
              key={index}
              sx={{
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 3,
                p: 2,
                display: "flex",
                gap: 2,
                alignItems: "center",
                cursor: "pointer",
                "&:hover": {
                  boxShadow: 2,
                },
              }}
            >
              <Box
                component="img"
                src={item.img}
                sx={{
                  width: 90,
                  height: 90,
                  borderRadius: 2,
                  backgroundColor: "primary.light",
                  p: 1,
                }}
              />
              <Box sx={{ fontWeight: 600 }}>{item.title}</Box>
            </Link>
          ))}
        </Box>
      </Box>
    </Paper>
  );
    const navigate = useNavigate();

  return (
    <AppBar position="sticky" elevation={0} sx={{ background: "transparent", padding: 2 }}>
      <Container maxWidth="xl" disableGutters>
        <Paper
          elevation={3}
          sx={{
            borderRadius: { xs: 2, md: 3 },
            backgroundColor: "background.default",
            mt: { xs: 0.5, sm: 1 },
            maxWidth: "1440px",
            mx: { xs: 1, sm: 2, lg: "auto" },
            px: {
              xs: 1.5,
              sm: 2,
              md: 3,
              lg: 4,
            },
            py: {
              // xs: 0.5,
              // sm: 0.75,
              // // md: 1,
            },
          }}
        >

          <Toolbar
            sx={{
              minHeight: {
                xs: 64,   // 📱 mobile
                sm: 64,   // 📲 tablet
                md: 72,   // 💻 small laptop
                lg: 80,   // 🖥️ desktop
              },
              px: {
                xs: 1,
                sm: 2,
                md: 3,
              },
              display: "flex",
              justifyContent: "space-between",
            }}
          >

            {/* LOGO */}
            <Box
              component="img"
              src={Logo}
              alt="Logo"
              sx={{
                height: {
                  xs: 50,
                  sm: 34,
                  md: 90,
                  lg: 90,
                },
              }}
            />


            {/* DESKTOP MENU */}
            <Box sx={{ display: { xs: "none", md: "flex" }, gap: 6 }}>
              {menuItems.map((item) => (
                <Button
                  key={item.id}
                  component={item.path ? RouterLink : "button"}
                  to={item.path || undefined}
                  onClick={(e) => {
                    if (location.pathname === item.path) {
                      e.preventDefault(); // stop re-navigation
                    }
                    handleMenuClick(item);
                  }} endIcon={
                    item.dropdown ? (
                      activeMenu === item.id ? (
                        <KeyboardArrowUpIcon />
                      ) : (
                        <KeyboardArrowDownIcon />
                      )
                    ) : null
                  }
                  sx={{
                    textTransform: "none",
                    fontWeight: 800,
                    fontSize: {
                      md: 25,
                      lg: 22,
                    },
                    color: "primary.main",
                  }}
                >
                  {item.label}
                </Button>
              ))}
            </Box>


            {/* DESKTOP RIGHT */}
            <Box sx={{ display: { xs: "none", lg: "flex" }, gap: 1 }}>
          
              <IconButton onClick={() => navigate("/contactus")}>
                <MailOutlineIcon />
              </IconButton>
              <Button
                component={RouterLink}
                to="/stayInTouch"
                variant="contained"
                sx={{
                  ...animatedButtonSx,
                  backgroundColor: "secondary.main",
                  color: "primary.main",
                  "&:hover": {
                    backgroundColor: "secondary.main",
                  },
                }}
              >
                <Box className="btn-text">Inquiry</Box>

                <Box
                  sx={{
                    width: 34,
                    height: 34,
                    borderRadius: "50%",
                    backgroundColor: "background.light",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <ArrowForwardIcon
                    className="arrow-icon"
                    sx={{ fontSize: 18, color: "primary.main" }}
                  />
                </Box>
              </Button>


            </Box>

            {/* MOBILE ICON */}
            <IconButton
              sx={{
                display: {
                  xs: "flex",   // 📱 mobile
                  sm: "flex",   // 📲 tablet
                  lg: "none",   // 💻 laptop
                },
              }}
              onClick={() => setMobileOpen(true)}
            >
              <MenuIcon />
            </IconButton>

          </Toolbar>
        </Paper>
      </Container>

      {/* MOBILE DRAWER */}
      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={() => {
          setMobileOpen(false);
          setMobileActiveMenu(null);
        }}
        PaperProps={{
          sx: {
            width: { xs: "100vw", sm: 380 },
            borderTopLeftRadius: { sm: 16 },
            borderBottomLeftRadius: { sm: 16 },
          },
        }}
      >

        <Box
          sx={{
            width: { xs: "100vw", sm: 360 },
            p: 2,
            height: "100vh",
            overflowY: "auto",
          }}
        >

          {/* MOBILE DRAWER HEADER */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 2,
            }}
          >
            {/* LOGO */}
            <Box component="img" src={Logo} sx={{ height: 40 }} />

            {/* RIGHT ICONS */}
            <Box sx={{ display: "flex", gap: 1 }}>
            

              <IconButton>
                <MailOutlineIcon />
              </IconButton>

              <IconButton
                onClick={() => {
                  setMobileOpen(false);
                  setMobileActiveMenu(null);
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>

          {menuItems.map((item) => (
            <Box key={item.id}>
              <Button
                fullWidth
                component={item.path ? RouterLink : "button"}
                to={item.path || undefined}
                onClick={() => handleMobileMenuClick(item)}
                endIcon={
                  item.dropdown ? (
                    mobileActiveMenu === item.id ? (
                      <KeyboardArrowUpIcon />
                    ) : (
                      <KeyboardArrowDownIcon />
                    )
                  ) : null
                }
                sx={{
                  justifyContent: "space-between",
                  textTransform: "none",
                  color: "primary.main",
                  fontWeight: 600,
                  py: 1.2,
                  mb: 1,
                  borderRadius: 2,
                  "&:hover": {
                    backgroundColor: "action.hover",
                  },
                }}

              >
                {item.label}
              </Button>

              {/* SAME MEGA MENU IN MOBILE */}
              {item.id === "products" && mobileActiveMenu === "products" && (
                <Box sx={{ mt: 2 }}>
                  {renderProductsMegaMenu()}
                </Box>
              )}
              {item.id === "news" && mobileActiveMenu === "news" && (
                <Box sx={{ mt: 2 }}>
                  {renderNewsMegaMenu()}
                </Box>
              )}

            </Box>
          ))}
          <Button
            component={RouterLink}
            to="/stayInTouch"
            variant="contained"
            sx={{
              ...animatedButtonSx,
              mt: 3,
              width: 150,
              backgroundColor: "secondary.main",
              color: "primary.main",
              "&:hover": {
                backgroundColor: "secondary.main",
              },
            }}
            onClick={() => setMobileOpen(false)}
          >
            <Box className="btn-text">Inquiry</Box>

            <Box
              sx={{
                width: 34,
                height: 34,
                borderRadius: "50%",
                backgroundColor: "background.light",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ArrowForwardIcon
                className="arrow-icon"
                sx={{ fontSize: 18, color: "primary.main" }}
              />
            </Box>
          </Button>


        </Box>
      </Drawer>

      {/* DESKTOP MEGA MENU */}
      {activeMenu === "products" && (
        <Box
          sx={{
            position: "absolute",
            top: "calc(100% + 12px)",
            left: {
              xs: 0,
              md: "50%",
            },
            transform: {
              xs: "none",
              md: "translateX(-50%)",
            },

            zIndex: 1300,
            mt: 2,
          }}
        >
          {renderProductsMegaMenu()}
        </Box>
      )}
      {activeMenu === "news" && (
        <Box
          sx={{
            position: "absolute",
            top: "100%",
            zIndex: 1300,
            mt: 2,
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          {renderNewsMegaMenu()}
        </Box>
      )}

    </AppBar>
  );
}
